import React from "react";
import "./listTopic.scss";

import { Col, Row, Stack } from "react-bootstrap";
import { gestioneSnackbar } from "../../utils/common";
import { t } from "i18next";

const ListTopic = ({
  data,
  title,
  textColor,
  selected,
  setSelected,
  disabled = true,
  width = "100%",
}) => {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <Stack gap={3} style={{ width }}>
        <h2
          className="title-topic"
          style={textColor ? { color: textColor } : null}
        >
          {title}
        </h2>
        <Row sm={3} className="g-2 d-flex justify-content-between">
          {data.map((item) => {
            return (
              <Col
                key={item.id}
                className="d-flex justify-content-center align-items-center"
              >
                <BoxTopic
                  id={item.id}
                  name={item.name}
                  image={item.image}
                  disabled={disabled}
                  setSelected={setSelected}
                  selected={selected}
                />
              </Col>
            );
          })}
        </Row>
      </Stack>
    </div>
  );
};

const BoxTopic = ({ id, name, image, setSelected, selected, disabled }) => {
  const handleSelect = (item) => {
    if (!disabled) {
      setSelected((prev) => {
        if (prev.includes(item)) {
          return prev.filter((i) => i !== item); // Rimuove se già selezionato
        } else if (prev.length < 3) {
          return [...prev, item]; // Aggiunge se meno di 3 elementi
        }
        gestioneSnackbar(true, t("validation.max_topic"), "error");
        return prev; // Non fa nulla se sono già 3
      });
    }
  };

  return (
    <Stack
      gap={1}
      className="d-flex justify-content-center align-items-center box-topic p-1"
      style={
        disabled
          ? null
          : { border: selected?.includes(id) ? "solid 2px #608ABD" : null }
      }
      onClick={() => (disabled ? null : handleSelect(id))}
    >
      <img src={image} alt="icon" />
      <span>{name}</span>
    </Stack>
  );
};

export default ListTopic;
